import StdReportEditor from './routerEditor';

export default StdReportEditor;
